import {
  QuotationRequestProps,
  QuotationRequestStatusEnum
} from '@/types'

export const accordionsByStatusObject: Record<
  QuotationRequestStatusEnum,
  Array<string>
> = {
  approved_for_quotation: [
    'general-information',
    'order-data',
    'catalog-products',
    'logistic-data',
  ],
  completed: ['general-information', 'catalog-products'],
  disqualified: ['general-information', 'catalog-products'],
  qualified: ['general-information', 'catalog-products'],
  expired: ['general-information', 'catalog-products'],
  invalid: ['general-information', 'catalog-products'],
  processed: ['general-information', 'catalog-products'],
  pending: ['general-information', 'catalog-products'],
  created: ['general-information', 'quotation-request-products'],
  draft: ['general-information', 'quotation-request-products'],
}

export const getQuotationRequestWithOrdenedItems = (
  quotationRequest?: QuotationRequestProps,
): QuotationRequestProps | undefined => {
  if (!quotationRequest) return

  const orderedItems = quotationRequest?.items?.sort((a, b) => {
    return (
      new Date(a.createdAt || '').getTime() -
      new Date(b.createdAt || '').getTime()
    )
  })

  return {
    ...quotationRequest,
    items: orderedItems,
  }
}
